<!-- 模板 -->
<template>
  <div class="mpage" v-cloak>
    <div>
      <div class="l-sjx"></div>
      左
    </div>
    <div>
      <div class="r-b-sjx"></div>
      右下
    </div>
  </div>
</template>

<script type="text/babel"> 
export default {
  name: 'Template',
  components: {},
  props: {},
  data() {
    return {

    }
  },
  watch: {

  },
  created() { },
  mounted() {


  },
  methods: {
    goMin() {

    },

  }
}
</script>

<style lang="scss" scoped>
.mpage {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  // 左
  .l-sjx {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 17.3px 10px 0;
    border-color: transparent #070807 transparent transparent;
  }
  // 右下
  .r-b-sjx {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 20px 20px;
    border-color: transparent transparent #070807 transparent;
    font-size: 12px;
  }
}
</style>
